<template>
  <el-dialog
    title="绑定出行人信息模版"
    width="70%"
    :visible.sync="dialogTravellerTemplateVisible"
    :showTravellerTemplate="showTravellerTemplate"
    @close="closeTravellerTemplate()"
  >
    <div class="title-and-choice" style="margin-bottom: 10px">
      <!-- 标题 -->
      <span class="title">{{ title }}</span>
      <!-- 按钮 -->
      <el-link
        class="choice-button-style"
        v-if="choice_visable_prop"
        @click="changeButtonClick"
        :underline="false"
        style="float: right; padding-left: 5px"
        type="info"
        icon="el-icon-sort"
        >修改</el-link
      >

      <el-link
        class="save-button-style"
        v-if="save_visable_prop"
        @click="cancleButtonClick"
        :underline="false"
        style="padding-left: 5px"
        type="info"
        >取消</el-link
      >

      <el-link
        class="save-button-style"
        v-if="save_visable_prop"
        @click="saveButtonClick"
        :underline="false"
        type="info"
        icon="el-icon-folder-checked"
        >保存</el-link
      >

      <!-- 内容展示 -->
      <div>
        <div v-if="show_content_visable_prop" class="choice_template_area">
          <!--如果为空，则显示 未绑定模版 -->
          <div v-if="content == ''">未绑定出行人信息模版</div>
          <!--否则，则显示模版内容 -->
          <div v-else>
            <div style="margin-bottom: 20px">当前模版名称：{{ temp_name }}</div>
            <div style="margin-bottom: 20px">
              是否必填：{{ temp_must_fill_in }}
            </div>
            <div style="margin-bottom: 30px">
              填写份数：{{ temp_one_everyone }}
            </div>
            <div style="display: inline">模版内容为：</div>
            <div
              style="display: inline"
              class="info-list-item-stype"
              v-for="(item, index) of content"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>

        <!-- 选择器 -->
        <div class="input">
          <!-- 对话框 -->
          <div
            v-if="show_input_prop"
            :class="{ class_name_one: false, class_name_two: true }"
          >
            <el-table :data="templateData">
              <el-table-column width="40%">
                <template slot-scope="scope">
                  <el-radio-group v-model="choicedTemplate">
                    <el-radio @change="checkedboxChange" :label="scope.row.id">
                      <span></span>
                    </el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column
                prop="id"
                label="ID"
                width="40%"
              ></el-table-column>
              <el-table-column
                prop="template_name"
                label="模版名称"
                width="150%"
              ></el-table-column>
              <el-table-column prop="mustFillIn" label="是否必填" width="100%">
                <template slot-scope="scope">
                  <span v-if="scope.row.mustFillIn == true">必填</span>
                  <span v-else>非必填</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="fillInOneOrEveryOne"
                label="要求"
                width="80%"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.fillInOneOrEveryOne == true"
                    >一人一份</span
                  >
                  <span v-else>多人一份</span>
                </template>
              </el-table-column>
              <el-table-column prop="template" label="模版内容">
                <template slot-scope="scope">
                  <div
                    class="info-list-item-stype"
                    v-for="(item, index) of scope.row.template"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "band-traveller-template",
  data() {
    return {
      dialogTravellerTemplateVisible: this.showTravellerTemplate,
      temp_name: this.template_name,
      temp_must_fill_in: this.template_must_fill_in,
      temp_one_everyone: this.template_one_everyone,
      templateData: [],
      info: "",
      is_editor: "",
      choicedTemplate: this.checkTravellerTemplate,
      choice_visable_prop: this.edit_visable,
      save_visable_prop: this.save_visable,
      show_input_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      // 输入组件
      input_textarea_width: "300px",
      input_text: this.input_text_content,
      input_textares: "",
      content: "",
    };
  },
  watch: {
    template_name: {
      handler(value) {
        this.temp_name = value;
      },
      immediate: true,
    },
    template_must_fill_in: {
      handler(value) {
        this.temp_must_fill_in = value;
      },
      immediate: true,
    },
    template_one_everyone: {
      handler(value) {
        this.temp_one_everyone = value;
      },
      immediate: true,
    },
    showTravellerTemplate: {
      handler(value) {
        this.dialogTravellerTemplateVisible = value;
      },
      immediate: true,
    },
    traveller_template_checked: {
      handler(Value) {
        this.content = Value;
      },
      immediate: true,
    },
    checkTravellerTemplate: {
      handler(newValue, oldValue) {
        this.choicedTemplate = newValue;
      },
      immediate: true,
    },
  },
  props: {
    title: String,
    template_name: String,
    template_must_fill_in: String,
    template_one_everyone: String,
    showTravellerTemplate: { type: Boolean, default: false },
    traveller_template_checked: Array, //动态绑定
    input_textares_width: String,
    checkTravellerTemplate: Number,
    sku_id: Number,
    // 样式
    // input_width: String,
    type: String,
    edit_visable: {
      type: Boolean,
      default: true,
    },
    save_visable: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    // 监听关闭
    closeTravellerTemplate() {
      this.$emit("update:showTravellerTemplate", false);
      this.content = [];
    },
    // 复制文本信息pastContent
    pastContent(event) {
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: "信息已复制到剪贴板",
          type: "success",
        });
      });
    },

    // 点击 修改 时的 方法
    changeButtonClick() {
      //  发送请求 获取所有模版
      this.$http.get("/get_traveller_template").then((res) => {
        const { data, errno, errmsg } = res.data;
        let templateData_list = [];

        for (let template of data) {
          const template_item = {};
          template_item.id = template.id;
          template_item.template_name = template.template_name;
          template_item.mustFillIn = template.mustFillIn;
          template_item.fillInOneOrEveryOne = template.fillInOneOrEveryOne;

          // 取出列表内容
          const item_template = template.template;
          if (item_template) {
            // 将template的字符串内容，变更为 对象
            let item_template_dict = new Function("return " + item_template)();
            const item_template_list = [];
            for (let item of item_template_dict) {
              item_template_list.push(item.name);
            }
            template_item.template = item_template_list;
          }
          templateData_list.push(template_item);
        }
        this.templateData = templateData_list;
      });
      this.save_visable_prop = true;
      this.choice_visable_prop = false;
      this.show_input_prop = true;
      this.show_content_visable_prop = false;
      //  this.$emit("change",this.)
      this.$emit("selectResTemplate");
    },
    // 点击保存按钮时
    saveButtonClick() {
      if (this.choicedTemplate == null) {
        this.$notify.error({
          title: "错误",
          message: "未选择需要绑定的模版",
        });
      } else {
        this.$http
          .get(
            `/product/band_traveller_template?sku_id=${this.sku_id}&template_id=${this.choicedTemplate}`
          )
          .then((res) => {
            const { data, errno, errmsg } = res.data;
            if (errno == "0") {
              // 获取模版内容，修改数据
              this.$http
                .get(`/get_traveller_template?id=${this.choicedTemplate}`)
                .then((res) => {
                  const { data, errno, errmsg } = res.data;
                  if (errno == "0") {
                    // 赋值组件的数据
                    if (data != undefined) {
                      //
                      this.choicedTemplate = data[0].id;
                      let template_content = new Function(
                        "return " + data[0].template
                      )();
                      let template_item = [];
                      for (let item of template_content) {
                        template_item.push(item.name);
                      }
                      this.content = template_item;
                      //
                      this.temp_name = data[0].template_name;
                      //
                      if (data[0].mustFillIn == false) {
                        this.temp_must_fill_in = "否";
                      } else {
                        this.temp_must_fill_in = "是";
                      }
                      //
                      if (data[0].fillInOneOrEveryOne == false) {
                        this.temp_one_everyone = "一人多份";
                      } else {
                        this.temp_one_everyone = "一人一份";
                      }

                      // 成功的通知
                      this.$notify({
                        title: "成功",
                        message: errmsg,
                        type: "success",
                      });
                      // 关闭显示
                      this.save_visable_prop = false;
                      this.choice_visable_prop = true;
                      this.show_input_prop = false;
                      this.show_content_visable_prop = true;
                    }
                  } else if (
                    errno == "4002" ||
                    errno == "4103" ||
                    errno == "4004"
                  ) {
                    this.$notify.error({
                      title: "错误",
                      message: errmsg,
                    });
                  }
                });
            }
          });
      }
      let sku_id = this.$emit(
        "save",
        this.input_text,
        this.checkTravellerTemplate
      );
    },
    // 取消编辑
    cancleButtonClick() {
      this.save_visable_prop = false;
      this.choice_visable_prop = true;
      this.show_input_prop = false;
      this.show_content_visable_prop = true;
    },
    // 监听选项改变值
    checkedboxChange() {},
  },
};
</script>

<style>
.title-and-choice:hover .choice-button-style {
  display: inline;
}
.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.choice_template_area {
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
}
.editor {
  margin-top: 10px;
}
.choice-button-style {
  display: none;
  font-size: 10px;
}
.save-button-style {
  font-size: 10px;
}
/* v-bind 绑定两种class */
.class_name_one {
  width: 100px;
}
.class_name_two {
  width: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid whitesmoke;
}
.info-list-item-stype {
  display: inline;
  color: white;
  margin-right: 5px;
  padding: 10px;
  background-color: #ff5421;
}
</style>